<template>
  <el-table
    v-loading="loading"
    class="mt-xl"
    header-row-class-name="table-header"
    :data="data"
    size="medium"
    border
    stripe
  >
    <el-table-column
      prop="stt"
      label="STT"
      align="center"
      width="80"
    >
      <template slot-scope="scope">
        {{ scope.row.stt }}
      </template>
    </el-table-column>
    <el-table-column
      v-for="(c, index) in columns"
      :key="index"
      :prop="c.key"
      :label="c.label"
      :align="c.column.align"
      :width="c.column.width"
      :min-width="c.column.min_width || '100px'"
    >
      <template slot-scope="scope">
        <span v-if="[fieldType.DATE, fieldType.DATETIME].includes(c.type)">
          {{ scope.row.extra[c.key] | convertDateTime(c.format) }}
        </span>
        <span v-if="[fieldType.SELECT].includes(c.type) && c.options.type">
          {{ scope.row.extra[c.key] | categoryName(allCategories) }}
        </span>
        <span v-else>
          {{ scope.row.extra[c.key] }}
        </span>
      </template>
    </el-table-column>
    <el-table-column
      v-if="isDelete"
      label="Thao tác"
      width="200"
      fixed="right"
      align="center"
    >
      <template slot-scope="scope">
        <el-dropdown
          trigger="click"
          @command="(command) => handleCommand(command, scope.row)"
        >
          <el-button
            size="medium"
            type="default"
            plain
          >
            Thao tác <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              key="detail"
              command="detail"
            >
              <i
                :class="'el-icon-document'"
                class="mr-s"
              />
              Chi tiết
            </el-dropdown-item>
            <el-dropdown-item
              key="delete"
              command="delete"
              class="text-danger"
            >
              <i
                :class="'el-icon-close'"
                class="mr-s"
              />
              Gỡ liên kết
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapGetters } from "vuex";
import constants from "@/config/constants";

export default {
  name: "CardList",
  components: {
  },
  props: {
    config: Object,
    data: Array,
    loading: Boolean,
    permission: Object,
    selectedPermission: Object
  },
  data() {
    return {
      fieldType: constants.FIELD_TYPE,
    };
  },
  computed: {
    ...mapGetters("category", ["allCategories"]),
    isDelete() {
      return this.permission.UPDATE && this.selectedPermission.UPDATE
    },
    columns() {
      const result = this.config?.extra?.fields || [];
      return result
        .filter((i) => i.show.column)
        .sort((a, b) => a.order - b.order);
    },
  },
  methods: {
    handleCommand(command, item) {
      this.$emit(command, item);
    },
  },
};
</script>

<style lang="scss"></style>
